import HomepageOnboarding from '../../assets/homepage_onboarding.png';
import OpenTicketOnboarding from '../../assets/open_ticket_onboarding.png';
import TicketDetailsOnboarding from '../../assets/ticket_details_onboarding.png';
import { IntroductionInterface } from '../../interfaces/IntroductionInterface';

export const onboardingSlides: IntroductionInterface[] = [
  {
    id: 'slide_1',
    header: 'Welcome, see how the new website can better support you.',
    headerMobile: 'How the new new website can better support you.',
    title: 'On the homepage...',
    titleMobile: 'On the homepage...',
    bulletItems: [
      {
        label: 'Troubleshoot your problem by searching forms and articles.',
      },
      {
        label: 'Quick access to the most commonly opened tickets.',
      },
      {
        label: 'See and easily respond to tickets that need your attention.',
      },
    ],
    bulletItemsMobile: [
      {
        label: 'Troubleshoot your problem by searching all of support.',
      },
      {
        label: 'Quickly open a commonly opened ticket.',
      },
      {
        label: 'See tickets that need your attention to get help faster.',
      },
    ],
    image: HomepageOnboarding,
    alt: 'Homepage Onboarding Image',
    kbArticle: 'KB0103095',
  },
  {
    id: 'slide_2',
    header: 'Welcome, see how the new Support Web can better support you.',
    headerMobile: 'How the new Support Web can better support you.',
    title: 'On the Open a Ticket page...',
    titleMobile: 'On the Open a Ticket page...',
    bulletItems: [
      {
        label: 'Easily find commonly opened tickets.',
      },
      {
        label: 'Search for the type of ticket you need to open.',
      },
    ],
    bulletItemsMobile: [
      {
        label: 'Easily find commonly opened tickets.',
      },
      {
        label: 'Search for the type of ticket you need to open.',
      },
    ],
    image: OpenTicketOnboarding,
    alt: 'Open a Ticket Onboarding Image',
    kbArticle: 'KB0103096',
  },
  {
    id: 'slide_3',
    header: 'Welcome, see how the new website can better support you.',
    headerMobile: 'How the new website can better support you.',
    title: 'On your ticket page...',
    titleMobile: 'On your ticket page...',
    bulletItems: [
      {
        label: 'See ticket updates and review your ticket chat.',
      },
      {
        label: 'Quickly add images or files to help with your ticket.',
      },
      {
        label: 'Easily share your ticket.',
      },
    ],
    bulletItemsMobile: [
      {
        label: 'See ticket updates and review your ticket chat.',
      },
      {
        label: 'Quickly add images or files to help with your ticket.',
      },
      {
        label: 'Easily share your ticket.',
      },
    ],
    image: TicketDetailsOnboarding,
    alt: 'Ticket Details Onboarding Image',
    kbArticle: 'KB0103097',
  },
];
